import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';    
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

// Components 

import Box from '@mui/material/Box';
import Button from '../../general/inputs/Button';
import { setIsBlockedAccountPopupOpened, setIsDeletedAccountPopupOpened, setIsLoginAttemptsWarningPopupOpened } from '../../../redux/features/general/navigation';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { setNotificationMessage } from '../../../redux/features/general/notification';
import CancelButton from '../../general/inputs/CancelButton';
import Popup from '../../general/popups/items/Popup';

interface Props { 

}; 

const LoginAttemptsWarningPopup: React.FC<Props> = ({ }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 

    // -- 

    const handleQuit = () => { 

        dispatch(setIsLoginAttemptsWarningPopupOpened(false)); 

    }; 
    
    // -- 

    return (

        <Popup>

            <Box
                component="img"
                sx={{
                    width: 100,
                    marginTop: 3, 
                    marginBottom: 2, 
                }}
                src={require('../../../assets/icons/login/warning.png')}
            />

            <Box
                sx={{ 
                    width: '50%',
                    marginBottom: 1 
                }}
            >{t('loginAttemptsWarning')}

            </Box>

            <Button 
                title={'continue'}
                triggerFunction={handleQuit}
                extraStyle={{ width: 200, marginBottom: 4 }}
            />

            <CancelButton handler={handleQuit} />

        </Popup>

  );

};

export default LoginAttemptsWarningPopup;